function clean(value) {
  return String(value ?? "").trim();
}

function toBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.toLowerCase() === "true";
  return Boolean(value);
}

export function isMappableTradeShow(show) {
  return Boolean(
    show &&
      toBoolean(show.exhibitor_directory_available) &&
      clean(show.exhibitor_directory_url) &&
      clean(show.exhibitor_provider),
  );
}
